import NotificationContent from './NotificationContent';
import { NotificationPopoverStyles } from './Notification.styles';
import { fetchUnreadNotificationAmountThunk } from '../../../../store/thunk/notificationThunk';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../../hooks/StoreHooks';

interface Props {
    anchorEl: any;
    onClose: () => void;
    open: boolean;
}

const NotificationPopover = (props: Props) => {
    const { anchorEl, onClose, open } = props;
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (open) {
            dispatch(fetchUnreadNotificationAmountThunk());
        }
    }, [open, dispatch]);

    return (
        <NotificationPopoverStyles
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={onClose}
            open={open}
        >
            <NotificationContent />
        </NotificationPopoverStyles>
    )
}

export default NotificationPopover